Flup.service("loader", function(flup){
   /* BUTTON FUNCTIONS ------------------------------------------- */
   function _getWhiteLoaderUrl() {
      return flup("server").makeUrl("/img/loader.svg");
   }
   function _getDarkLoaderUrl() {
      return flup("server").makeUrl("/img/loader-dark.svg");
   }

   this.getDarkLoaderUrl = _getDarkLoaderUrl;
   this.getWhiteLoaderUrl = _getWhiteLoaderUrl;
   
   this.preloadImages = function(){
      (new Image()).src = _getWhiteLoaderUrl();
      (new Image()).src = _getDarkLoaderUrl();
   }

   var _id = 0;
   this.loading = function($elm, darkLoader) {
      if(!$elm.length) return;
      _id++;
      var id = "loader-"+_id;
      var url = darkLoader ? _getDarkLoaderUrl() : _getWhiteLoaderUrl();
      $elm.data("loaderId", id).addClass("is-loading");
      var offset = $elm.offset();
      $("body").append($("<div />").attr("id", id).css({
         "position": "absolute",
         "top": offset.top,
         "left": offset.left,
         "width": $elm.outerWidth(),
         "height": $elm.outerHeight(),
         "background-image": "url('" + url + "')",
         "background-repeat": "no-repeat",
         "background-position": "center",
         "background-size": "35px 35px",
         "z-index": "9999",
      }));
      return id;
   }

   this.remove = function($elm, id){
      $elm.removeClass("is-loading");
      id = id || $elm.data("loaderId");
      $("#"+id).remove();
   }

   
   this.loadingFull = function(){
      this.removeFull();
      var $fullLoader = $("<div id='full-loader'></div>").css({
         "position": "fixed",
         "top": 0,
         "left": 0,
         "width": "100%",
         "height": "100%",
         "background-color": "rgba(255,255,255,0.8)",
         "z-index": "9999999",
         "background-image": "url('" + _getDarkLoaderUrl() + "')",
         "background-repeat": "no-repeat",
         "background-position": "center center"
      });

      $("html,body").addClass("is-full-loader");
      $("body").append($fullLoader);
   }

   this.removeFull = function(){
      $("html,body").removeClass("is-full-loader");
      $("#full-loader").remove();
   }
   /*that.loadingLayer = function(loading, $elm, blueLoader){
      if(loading){
         var url = blueLoader ? _getBlueLoaderUrl() : _getWhiteLoaderUrl();
         var $loadingLayer = $("<div loading-layer />").css({
            "position": "absolute", "top": 0, "left": 0, "width": '100%', "height": '100%',
            "background-image": "url('" + url + "')", "background-repeat": "no-repeat",
            "background-position": "center", "background-size": "35px 35px",
            "z-index": "9999"
         });
         $elm.addClass("is-loading").append($loadingLayer);
      }
      else{
         $elm
         .removeClass("is-loading")
         .find("[loading-layer]").remove();
      }
   }*/
});

Flup.init(function(flup){
   flup("loader").preloadImages();
});